import { z } from 'zod';
import { isToday, isFuture } from 'date-fns'

export const formSchema = z.object({
  priority: z.string({ required_error: 'Selecione a prioridade' }),
  comment: z.string().optional(),
  deliveryForecastDate: z.date({ required_error: 'Selecione uma data' }).refine((date) => {
    return isFuture(date) || isToday(date);
  }, {
    message: 'A data não pode ser retroativa',
  }),
});

export type FormSchema = z.infer<typeof formSchema>;